export default {
    quote: 'Eerlijk bloeit het langst!',
    quoter: 'The Happy Activist',
    link: 'https://www.instagram.com/p/B9BQ8jxlsWK/',
};